<template>
  <div v-if="!item.hidden && item.children" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <menu-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon :icon-class='onlyOneChild.meta.icon || item.meta.icon'></svg-icon>
          <span v-if="onlyOneChild.meta" :title="onlyOneChild.meta.title">{{onlyOneChild.meta.title}}</span>
        </el-menu-item>
      </menu-link>
    </template>

    <el-submenu v-else :index="resolvePath(item.path)">
      <template slot="title">
        <svg-icon :icon-class='item.meta.icon'></svg-icon>
        <span v-if="item.meta" :title="item.meta.title">{{item.meta.title}}</span>
      </template>

      <template v-for="child in item.children">
        <template v-if="!child.hidden">
          <sidebar-item v-if="child.children && child.children.length>0" :is-nest="true" :item="child" :key="child.path" :base-path="resolvePath(child.path)" class="nest-menu" />
          <menu-link v-else :to="resolvePath(child.path)" :key="child.name">
            <el-menu-item :index="resolvePath(child.path)">
              <svg-icon :icon-class='child.meta.icon'></svg-icon>
              <span v-if="child.meta.title" :title="child.meta.title">{{child.meta.title}}</span>
            </el-menu-item>
          </menu-link>
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';
import { isExternal } from '@/assets/utils/JiachenPanUtil';
import MenuLink from './MenuLink';

export default {
  name: 'SideBarItem',

  components: { MenuLink },

  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      onlyOneChild: null,
    }
  },

  methods: {
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter(item => {
        if(item.hidden) {
          return false
        }else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if(showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if(showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },

    resolvePath(routePath) {
      if(this.isExternalLink(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },

    isExternalLink(routePath) {
      return isExternal(routePath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/SideBarItem.vue